var map = {
	"./symbol_0.png": "8e53",
	"./symbol_1.png": "4172",
	"./symbol_10.png": "27ba",
	"./symbol_11.png": "b9ae",
	"./symbol_12.png": "576b",
	"./symbol_2.png": "7b28",
	"./symbol_3.png": "2c90",
	"./symbol_4.png": "65ab",
	"./symbol_5.png": "e822",
	"./symbol_6.png": "e09a",
	"./symbol_7.png": "c31c",
	"./symbol_8.png": "2650",
	"./symbol_9.png": "594a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ff7";